import React from "react";
import {
  Link as RRLink,
  NavLink as RRNavLink,
  Navigate as RRNavigate,
  useNavigate as useRRNavigate,
} from "react-router-dom";
import i18n from "@/i18n";

export * from "react-router-dom";

export function currentLang() {
  return (i18n.language || "it").startsWith("en") ? "en" : "it";
}

// Prefix an app-absolute path with /en when the active language is English.
export function localizePath(to) {
  if (typeof to !== "string") return to;
  if (currentLang() !== "en") return to;
  if (to === "/") return "/en";
  if (to === "/en" || to.startsWith("/en/")) return to;
  if (to.startsWith("/")) return "/en" + to;
  return to;
}

export const Link = React.forwardRef(function Link({ to, ...rest }, ref) {
  return <RRLink ref={ref} to={localizePath(to)} {...rest} />;
});

export const NavLink = React.forwardRef(function NavLink({ to, ...rest }, ref) {
  return <RRNavLink ref={ref} to={localizePath(to)} {...rest} />;
});

export function Navigate({ to, ...rest }) {
  return <RRNavigate to={localizePath(to)} {...rest} />;
}

export function useNavigate() {
  const nav = useRRNavigate();
  return React.useCallback(
    (to, opts) => nav(typeof to === "number" ? to : localizePath(to), opts),
    [nav],
  );
}
